import { createSelector } from 'reselect';
import getConnectedAccounts from './getConnectedAccounts';
export const hasConfiguredEmail = createSelector([getConnectedAccounts], emailAccounts => !emailAccounts.isEmpty());